export const AUTHOR_SET_PUBLICS = 'AUTHOR_SET_PUBLICS';
export const AUTHOR_SET_MARATHONED_PUBLICS = 'AUTHOR_SET_MARATHONED_PUBLICS';
export const AUTHOR_ADD_MARATHONED_PUBLIC = 'AUTHOR_ADD_MARATHONED_PUBLIC';
export const AUTHOR_UPDATE_FILTERED_PUBLICS = 'AUTHOR_UPDATE_FILTERED_PUBLICS';
export const AUTHOR_UPDATE_MARATHONED_FILLED_PUBLICS = 'AUTHOR_UPDATE_MARATHONED_FILLED_PUBLICS';
export const AUTHOR_SELECT_PUBLIC = 'AUTHOR_SELECT_PUBLIC';
export const AUTHOR_SET_IS_SHOW_MORE_OPEN_STATUS = 'AUTHOR_SET_IS_SHOW_MORE_OPEN_STATUS';
export const AUTHOR_SET_TYPES = 'AUTHOR_SET_TYPES';
export const AUTHOR_SELECT_TYPE = 'AUTHOR_SELECT_TYPE';
